import { render } from "./LeistungspruefungTHL.vue?vue&type=template&id=d21f67b6"
import script from "./LeistungspruefungTHL.vue?vue&type=script&lang=js"
export * from "./LeistungspruefungTHL.vue?vue&type=script&lang=js"

import "./LeistungspruefungTHL.vue?vue&type=style&index=0&id=d21f67b6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__